var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/store/slices/userSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
export var tokenKey = 'token';
var initialState = {
    isLoggedIn: false,
    username: '',
    publicId: '',
    userId: 0,
    timesRemaining: 0,
    isDraftUpdated: 0,
    loading: false,
    errors: null,
};
// Create an async thunk for login
export var updateLocalStorageAttribute = function (attribute, value) {
    var storedData = localStorage.getItem(tokenKey);
    console.log(storedData);
    if (storedData) {
        var parsedData = JSON.parse(storedData);
        parsedData[attribute] = value;
        localStorage.setItem(tokenKey, JSON.stringify(parsedData));
    }
};
export var loginAsync = createAsyncThunk('user/login', function (credentials, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post('loginForm', credentials)];
            case 1:
                response = _a.sent();
                if (response.data.status === true) {
                    localStorage.setItem(tokenKey, JSON.stringify({ id: response.data.user.id, name: response.data.user.name, public_id: response.data.user.public_id, times_remaining: response.data.user.times_remaining, is_draft_updated: response.data.user.is_draft_updated }));
                    return [2 /*return*/, response.data.user];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response.data.errors)];
                }
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                if (axios.isAxiosError(error_1) && error_1.response) {
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_1.response.data.errors)];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue('An unknown error occurred')];
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var resetPinAsync = createAsyncThunk('user/reset-pin', function (phone_number, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post('reset-pin', { phone_number: phone_number })];
            case 1:
                response = _a.sent();
                if (response.data.status === 'success') {
                    return [2 /*return*/, "OTP sent successfully"];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue(response.data.errors)];
                }
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                if (axios.isAxiosError(error_2) && error_2.response) {
                    if (error_2.response.data && error_2.response.data.message)
                        return [2 /*return*/, thunkAPI.rejectWithValue(error_2.response.data.message)];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue('An unknown error occurred')];
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); });
var userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        logout: function (state) {
            state.isLoggedIn = false;
            state.username = '';
            state.userId = 0;
            state.publicId = '';
            state.timesRemaining = 0;
            state.isDraftUpdated = 0;
            localStorage.removeItem(tokenKey);
            axios.get('logout_user')
                .then(function () {
                console.log('User logged out');
            })
                .catch(function (error) {
                console.error('Error logging out:', error);
            });
        },
        updateUserState: function (state, action) {
            var _a = action.payload, key = _a.key, value = _a.value;
            state[key] = value;
            console.log('Updated state:', state);
            console.log('Updated key:', key);
            console.log('Updated value:', value);
        },
        autoLogin: function (state) {
            var token = localStorage.getItem(tokenKey);
            console.log("autoLogin token: ".concat(token));
            if (token && state.isLoggedIn === false) {
                var userData = JSON.parse(token);
                state.isLoggedIn = true;
                state.username = userData.name;
                state.userId = userData.id;
                state.timesRemaining = userData.times_remaining;
                state.isDraftUpdated = userData.is_draft_updated;
                state.publicId = userData.public_id;
            }
        }
    },
    extraReducers: function (builder) {
        builder
            .addCase(loginAsync.pending, function (state) {
            state.loading = true;
            state.errors = null;
        })
            .addCase(loginAsync.fulfilled, function (state, action) {
            state.isLoggedIn = true;
            var user = action.payload;
            state.username = user.name;
            state.userId = user.id;
            state.publicId = user.public_id;
            state.timesRemaining = user.times_remaining;
            state.isDraftUpdated = user.is_draft_updated;
            state.loading = false;
        })
            .addCase(loginAsync.rejected, function (state, action) {
            state.loading = false;
            state.errors = action.payload;
        });
    },
});
export var logout = (_a = userSlice.actions, _a.logout), autoLogin = _a.autoLogin, updateUserState = _a.updateUserState;
export default userSlice.reducer;
